import {axios} from "react-netjoy";

const RequestSuccessInterceptor: axios.AxiosInterceptorRequestSuccessInputFunctionType<{}> = (config, serviceClient) => {
    console.log('RequestSuccessInterceptor')
    console.log(JSON.stringify(config))
    return config
}

export default RequestSuccessInterceptor;
